import React, { useState, useEffect } from 'react';
import { Listbox } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';

const MonthYearListbox = ({ selectedMonth, setSelectedMonth }) => {
    const [options, setOptions] = useState([]);
    const optionsPerPage = 10;

    useEffect(() => {
        const currentDate = new Date();
        const initialOptions = generateOptions(currentDate, -5, 5);
        setOptions(initialOptions);
        if (!selectedMonth) {
            setSelectedMonth(currentDate);
        }
    }, [selectedMonth, setSelectedMonth]);

    const generateOptions = (startDate, back, forward) => {
        const newOptions = [];
        for (let i = back; i <= forward; i++) {
            const date = new Date(startDate.getFullYear(), startDate.getMonth() + i);
            const year = date.getFullYear();
            const monthName = date.toLocaleString('it-IT', { month: 'long' });
            const formattedMonthName = monthName.charAt(0).toUpperCase() + monthName.slice(1);
            newOptions.push({ value: date, label: `${year} ${formattedMonthName}` });
        }
        return newOptions;
    };

    const handleScroll = (e) => {
        if (e.target.scrollTop === 0) {
            const firstOption = options[0].value;
            const newOptions = generateOptions(firstOption, -optionsPerPage, -1);
            setOptions([...newOptions, ...options]);
        } else if (e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight) {
            const lastOption = options[options.length - 1].value;
            const newOptions = generateOptions(lastOption, 1, optionsPerPage);
            setOptions([...options, ...newOptions]);
        }
    };

    const handleSelect = (option) => {
        setSelectedMonth(option);
    };

    return (
        <Listbox value={selectedMonth} onChange={handleSelect}>
            <div className="relative z-50">
                <Listbox.Button className="border border-gray-300 rounded-md shadow-md p-2 pl-4 flex items-center w-60 justify-between">
                    <span>
                        {selectedMonth ? `${selectedMonth.getFullYear()} ${selectedMonth.toLocaleString('it-IT', { month: 'long' }).charAt(0).toUpperCase() + selectedMonth.toLocaleString('it-IT', { month: 'long' }).slice(1)}` : 'Seleziona Mese e Anno'}
                    </span>
                    <ChevronDownIcon className="h-5 w-5 text-gray-500" />
                </Listbox.Button>
                <Listbox.Options
                    onScroll={handleScroll}
                    className="absolute z-10 mt-1 max-h-60 overflow-y-auto border rounded bg-white shadow-lg w-60"
                >
                    {options.map((option, index) => (
                        <Listbox.Option key={index} value={option.value} className={({ active }) => `cursor-default select-none relative py-2 pl-10 pr-4 ${active ? 'bg-indigo-100' : 'text-gray-900'}`}>
                            {option.label}
                        </Listbox.Option>
                    ))}
                </Listbox.Options>
            </div>
        </Listbox>
    );
};

export default MonthYearListbox;
